module.exports = __webpack_public_path__ + "static/media/img_plan_premium.0fa56882.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img_plan_premium.svg
// module id = 384
// module chunks = 0